module.exports = __webpack_public_path__ + "fonts/SF-Pro-Display-Ultralight.bc55c63e.otf";